/**
 * @file Route: 24x48
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import "components/Cover";
// FIXME: error with scrolltrigger
// import trackCollectionImpressions from "utils/trackCollectionImpressions";
import trackCollectionLinks from "utils/trackCollectionLinks";
import { $, $all, forEach, on } from "@olmokit/dom";
import { Header } from "components/Header/Info";
import { breakpoints, gridGutter } from "@olmokit/core/scss";
import { glide, Swipe, Breakpoints } from "@olmokit/core/glide";
import "./index.scss";

// import { clickCta } from "components/Dl";

console.log("Route 24x48/index.js mounted.");

Header();

glide(
  ".benefits:row",
  {
    loop: false,
    killWhen: { above: breakpoints.xl },
    // bound: true,
    gap: gridGutter,
    breakpoints: {
      [breakpoints.xl]: {
        perView: 4.5
      },
      [breakpoints.lg]: {
        perView: 3.5
      },
      [breakpoints.md]: {
        perView: 2.3
      },
      [breakpoints.sm]: {
        perView: 1.3
      }
    }
  },
  { Swipe, Breakpoints }
);

glide(
  ".myths:row",
  {
    loop: false,
    killWhen: { above: breakpoints.lg },
    // bound: true,
    gap: gridGutter,
    breakpoints: {
      [breakpoints.lg]: {
        perView: 3
      },
      [breakpoints.md]: {
        perView: 2.3
      },
      [breakpoints.sm]: {
        perView: 1.3
      }
    }
  },
  { Swipe, Breakpoints }
);

// trackCollectionImpressions();
trackCollectionLinks();

const ctas = $all(".dlClickCta");
if (ctas) {
  forEach(ctas, c => {
    on(c, "click", () => {
    //   clickCta(c.getAttribute("data-link"), c.getAttribute("data-label"));
    });
  });
}
